import React, { Fragment, useState } from 'react';
import AdminSidebar from './navigation/AdminSidebar';
import { Outlet, useNavigate } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa';
import { FiMenu } from 'react-icons/fi';
import { FaFileInvoice } from 'react-icons/fa6';
import OrderNotification from './OrderNotification';
import bestBasketLogo from './images/bestBasketLogo.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function LandingPageAdmin() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogOut = () => {
    if (!window.confirm("Are you sure you want to log out?")) return;

    localStorage.removeItem('authToken');
    navigate('/admin-login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <Fragment>
      <div className="container-fluid p-0 overflow-hidden">
        <div className="row m-0">
          <div className="col-12 admin-navbar p-0 d-flex">
            {/* Brand Section: Continuous dark blue background, width matches sidebar */}
            <div className="admin-navbar-brand-section">
              <img src={bestBasketLogo} alt="logo" className="admin-navbar-logo" />
            </div>

            {/* Control Section: Continuous dark blue background, remaining width */}
            <div className="admin-navbar-control-section">
              <button
                className="mobile-menu-toggle admin-navbar-toggle-btn"
                onClick={toggleSidebar}
                aria-label="Toggle sidebar"
              >
                <FiMenu />
              </button>
              <img src={bestBasketLogo} alt="logo" className="admin-navbar-logo-mobile" />
              <div className="admin-navbar-actions-container d-flex gap-3 align-items-center ms-auto">
                {/* Busy Accounting Shortcut */}
                <button
                  onClick={() => toast.info('Busy - Coming Soon', { position: 'top-right', autoClose: 3000, icon: false })}
                  title="Busy Accounting"
                  className="admin-navbar-logout-btn"
                >
                  <FaFileInvoice />
                </button>
                <OrderNotification />
                <button
                  onClick={handleLogOut}
                  title="Logout"
                  className="admin-navbar-logout-btn"
                >
                  <FaSignOutAlt />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className={`col-lg-3 col-md-4 col-sm-12 admin-sidebar-container ${sidebarOpen ? 'mobile-open' : ''}`}>
            <AdminSidebar onItemClick={closeSidebar} />
          </div>
          <div className="col-lg-9 col-md-8 col-sm-12 p-0 overflow-hidden admin-content">
            <Outlet />
          </div>
        </div>
      </div>
      
      {/* Mobile overlay */}
      <div 
        className={`mobile-overlay ${sidebarOpen ? 'active' : ''}`} 
        onClick={closeSidebar}
      ></div>

      {/* Global Toast Alerts */}
      <ToastContainer style={{ marginTop: '50px' }} />
    </Fragment>
  );
}

export default LandingPageAdmin;
